const isProduction = process.env.NODE_ENV === "production";
export const WIDGET_APP_ORIGIN = process.env.NEXT_PUBLIC_APP_ORIGIN || (isProduction ? "https://noahub.ai" : "http://localhost:3000");
export const WIDGET_BACKEND_URL = process.env.NEXT_PUBLIC_WIDGET_API_BASE_URL ||
    process.env.NEXT_PUBLIC_API_URL ||
    (isProduction ? "https://api.noahub.ai/api" : "http://localhost:8000/api");
export const DEFAULT_AGENT_IMAGE = "/images/agents/data-collection-agent-red.png";
export function getWidgetAppOrigin() {
    if (typeof document !== "undefined") {
        const script = document.currentScript ||
            document.querySelector("script[data-chatbot-widget]") ||
            document.querySelector('script[src*="chatbot-widget.js"]');
        const src = script === null || script === void 0 ? void 0 : script.getAttribute("src");
        if (src) {
            try {
                return new URL(src, window.location.href).origin;
            }
            catch {
                // Fall through to the configured origin.
            }
        }
    }
    return WIDGET_APP_ORIGIN;
}
export function resolveWidgetAssetUrl(value) {
    const trimmed = typeof value === "string" ? value.trim() : "";
    if (!trimmed)
        return null;
    if (/^(?:https?:|data:|blob:)/i.test(trimmed))
        return trimmed;
    if (trimmed.startsWith("//"))
        return `https:${trimmed}`;
    const origin = getWidgetAppOrigin();
    return `${origin}${trimmed.startsWith("/") ? trimmed : `/${trimmed}`}`;
}
